import React, { useState, useRef } from "react";
import moment from "moment";
import Header from "../../Common/Layout/Header";
import destinations from "../../Data/SightseeingDestinations.json";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import SightSeeingTabs from "../AllTabs/SightSeeingTabs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RiCalendarLine, RiMapPinLine, RiSearchLine } from "react-icons/ri";
import SightseeingOffers from "../Advertisements/SightseeingOffers";

const SightSeeingSearch = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [destination, setDestination] = useState("");
  const [destinationCode, setDestinationCode] = useState(0);
  const [travelDate, setTravelDate] = useState(() => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    return currentDate;
  });
  const [adults, setAdults] = useState(1);
  const [kids, setKids] = useState(0);
  const [errors, setErrors] = useState({});

  // Custom input component for date picker (same as in your other components)
  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        placeholder="Select date"
      />
      <button className="btn btn-secondary" type="button" onClick={onClick}>
        <RiCalendarLine />
      </button>
    </div>
  ));

  const validate = () => {
    let temp = {};
    temp.destination = destination === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleSearch = (e) => {
    e.preventDefault();
    if (validate()) {
      const searchQuery = {
        destination: destination,
        destinationCode: destinationCode,
        adults: adults,
        kids: kids,
        travelDate: moment(travelDate).format("YYYY-MM-DD"),
        currencyCode: user?.currency,
        companyId: user?.isSupplierAPI === true ? user.cid : user.parentCompanyId,
      };
      //navigate('/activities/' + destinationCode + "/" + destination + "/" + adults+ "/" + kids + "/" + moment(travelDate).format('YYYY-MM-DD'), { state: { searchQuery } });
      navigate(
        "/sightseeing/products/" +
          destinationCode +
          "/" +
          destination +
          "/" +
          adults +
          "/" +
          kids +
          "/" +
          moment(travelDate).format("YYYY-MM-DD"),
        { state: { searchQuery } }
      );
    }
  };
  const handleIncreaseAdults = (e) => {
    setAdults(parseFloat(adults + 1));
  };
  const handleDecreaseAdults = (e) => {
    if (adults !== 1) {
      setAdults(parseFloat(adults - 1));
    }
  };
  const handleIncreaseKids = (e) => {
    setKids(parseFloat(kids + 1));
  };
  const handleDecreaseKids = (e) => {
    if (kids !== 0) {
      setKids(parseFloat(kids - 1));
    }
  };
  const handleDepartureDate = (date) => {
    const selectedDate = date;
    setTravelDate(selectedDate);
  };
  const [departureResults, setDepartureResults] = useState([]);
  const inputDRef = useRef(null);
  const handleDepartureAirportSearch = (e) => {
    const value = e.target.value;
    setDestination(value);
    if (value.length > 0) {
      const filteredAirports = destinations
        .filter((airport) =>
          airport.destinationName.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setDepartureResults(filteredAirports);
    } else {
      setDepartureResults([]);
    }
  };
  const handleDepartureAirportClick = (e) => {
    let filteredAirports = destinations.filter(function (p) {}).slice(0, 10);
    setDepartureResults(filteredAirports);
    inputDRef.current.select();
  };
  const handleDepartureSelect = (data) => {
    setDestinationCode(data.parentId);
    setDestination(data.destinationName);
    setDepartureResults([]);
  };
  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card pt-0">
              <div className="p-2">
                <SightSeeingTabs pageName="SEARCH" />
              </div>
              <div className="card-body">
                <div className="row gy-3 gx-lg-2 gx-3">
                  <div className="col-12 pb-2 fs-5">SEARCH DESTINATIONS</div>
                  <div className="col-3">
                    <label htmlFor="iconInput" className="form-label">
                      DESTINATION
                    </label>
                    <div className="form-icon position-relative">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search Destination Ex: Dubai"
                        value={destination}
                        onChange={handleDepartureAirportSearch}
                        onClick={handleDepartureAirportClick}
                        onFocus={handleDepartureAirportClick}
                        ref={inputDRef}
                      />
                      <RiMapPinLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
                    </div>
                    {errors.destination === false ? (
                      <div className="validationerror">
                        Please select destination{" "}
                      </div>
                    ) : (
                      ""
                    )}
                    {departureResults.length > 0 && (
                      <ul
                        className="locationListVideo scrollable-list"
                        style={{ minWidth: "350px", maxWidth: "400px" }}
                      >
                        {departureResults.map((city) => (
                          <li
                            className="locationListVideoItem"
                            key={city.destinationId}
                            onClick={() => handleDepartureSelect(city)}
                          >
                            {city.destinationName}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <div className="col-2">
                    <label htmlFor="iconInput" className="form-label">
                      TRAVEL DATE
                    </label>
                    <DatePicker
                      selected={travelDate}
                      onChange={handleDepartureDate}
                      customInput={<CustomDateInput />}
                      dateFormat="dd-MMM-yyyy"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      minDate={new Date()}
                      yearDropdownItemNumber={50}
                      scrollableYearDropdown
                      className="form-control"
                      placeholder="TRAVEL DATE"
                    />
                    {errors.travelDate === false ? (
                      <div className="validationerror">
                        Please select travel date{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-3">
                    <label htmlFor="iconInput" className="form-label">
                      TRAVELLERS
                    </label>
                    <div class="dropdown" data-bs-auto-close="outside">
                      <div
                        class=" form-control w-100 dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {adults + " Adults, " + kids + " Kids"}
                      </div>
                      <div
                        className="dropdown-menu p-3"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                          <span>Adults</span>
                          <div className="input-step d-flex align-items-center">
                            <button
                              type="button"
                              className="minus"
                              onClick={handleDecreaseAdults}
                            >
                              –
                            </button>
                            <input
                              type="number"
                              className="product-quantity text-center"
                              min="1"
                              max="9"
                              readOnly
                              value={adults}
                              name="adults"
                            />
                            <button
                              type="button"
                              className="plus"
                              onClick={handleIncreaseAdults}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                          <span>Kids</span>
                          <div className="input-step d-flex align-items-center">
                            <button
                              type="button"
                              className="minus"
                              onClick={handleDecreaseKids}
                            >
                              –
                            </button>
                            <input
                              type="number"
                              className="product-quantity text-center"
                              min="0"
                              max="9"
                              readOnly
                              value={kids}
                              name="kids"
                            />
                            <button
                              type="button"
                              className="plus"
                              onClick={handleIncreaseKids}
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-auto px-1" style={{ paddingTop: "28px" }}>
                    <div className="form-group mb-0">
                      <button
                        type="button"
                        className="btn btn-danger full-width fw-medium"
                        onClick={handleSearch}
                      >
                        <RiSearchLine className="ms-2" />
                        SEARCH
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <SightseeingOffers />
          </div>
          {/* end row */}
        </div>
        {/* container-fluid */}
      </div>
    </div>
  );
};

export default SightSeeingSearch;
